import React from 'react';
import editorForValue from './editors';

const FieldEditView = React.memo(({value, ...props}) => {
	const Comp = editorForValue(value);
	if(Comp)return <Comp value={value} {...props}/>;
	return null;
});

export default FieldEditView;